// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__2PJ1Y","overlay":"Banner_overlay__pmVqa","title":"Banner_title__342da","subtitle":"Banner_subtitle__1bcJw"};